import styled from "styled-components";

export const CardAngularGradientWrapper = styled.div`
  border: 1px solid #e0e0e0;
  padding: 24px 20px;
  overflow: hidden;
  background: conic-gradient(
      from 40.26deg at 46.13% 65.14%,
      #efe9ff 0deg,
      #ffffff 360deg
    ),
    radial-gradient(
      100% 100% at 0% 0%,
      rgba(218, 204, 255, 0.34) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  border-radius: 10px;
  width: clamp(300px, 100%, 400px);
  min-height: 160px;
  position: relative;
  & > :has(:not(img)) {
    position: relative;
    z-index: 2;
  }
`;

export const FooterImg = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  object-fit: contain;
  z-index: 1;
`;
